import { createMakeTrafficSelectors } from '@make-software/tg-mini-app-ui';

import { RootState } from '../store';

export const {
  selectTaskManagerStatus,
  selectTasks,
  selectSelectedTask,
  selectMakeTrafficError,
  selectIsTasksLoading
} = createMakeTrafficSelectors((state: RootState) => state.makeTraffic);
